// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".children-tab .ant-tabs-ink-bar{background:#eee}.children-tab .ant-tabs-nav{background:#eee;width:100vw;padding:0 20px}.children-tab .ant-progress-show-info .ant-progress-outer{margin-right:calc(-2em - 40px);padding-right:calc(2em + 40px)}\n", ""]);
// Exports
module.exports = exports;
